import React from 'react';
import './ContactForm.scss';
import icon from '../../assets/banner/icons/Calling.png';

const ContactForm = () => {
    return (
        <form>
            <div className="row">
                <div className="col-lg-6">
                    <div class="form-group">
                        <label>Nome</label>
                        <input type="email" class="form-control" placeholder="Digite seu nome..." />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div class="form-group">
                        <label>E-mail</label>
                        <input type="email" class="form-control" placeholder="Digite seu e-mail..." />
                    </div>
                </div>
                <div className="col-lg-6">
                    <div class="form-group">
                        <label>Serviço</label>
                        <select class="form-control">
                            <option>Clareamento Dentário</option>
                            <option>Limpeza Dental</option>
                            <option>Implantes</option>
                            <option>Ortodontia</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div class="form-group">
                        <label>Departmento</label>
                        <select class="form-control">
                            <option>Selecione o Departamento</option>
                            <option>Odontologia Estética</option>
                            <option>Cirurgia Dentária</option>
                            <option>Ortodontia</option>
                        </select>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div class="form-group">
                        <label for="exampleFormControlTextarea1">Mensagem</label>
                        <textarea class="form-control" placeholder='Digite sua mensagem...' rows="3"></textarea>
                    </div>
                </div>

                <div className="col-lg-6">
                    <button type="submit" class="btn appointment-btn"></button>
                </div>
                <div className="col-lg-6">
                    <div className="appointment-call">
                        <div className='icon'>
                            <img src={icon} alt="icon" />
                        </div>
                        <div className='call-text'>
                            <p>Emergência Dental 24H</p>
                            <h6> 943 283 366 / 929059545</h6>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default ContactForm;